'use client'

import { useEffect, useState } from 'react'

import { useAddressStoreActions, useDeliveryAddress } from '@/stores/useAddressStore'
import { usePickupDateBag } from '@/stores/useDateStore'
import type { ApiAddressSuggestion } from '@/types/address-suggestions'

import { PickupLocationForm } from './pickup-location-form'
import { PickupLocationMap } from './pickup-location-map'

import 'mapbox-gl/dist/mapbox-gl.css'
import { OSLO_LOCATION } from '@/lib/constants'

import { Viewport } from '@/types/maps'

const INITIAL_VIEWPORT: Viewport = {
  latitude: OSLO_LOCATION.latitude,
  longitude: OSLO_LOCATION.longitude,
  zoom: 10,
}

export const PickupLocation = () => {
  const [_isInErrorState, setIsInErrorState] = useState(false)
  const [viewport, setViewport] = useState(INITIAL_VIEWPORT)
  const [markerCoordinates, setMarkerCoordinates] = useState(OSLO_LOCATION)
  const pickupDateBag = usePickupDateBag()
  const deliveryAddress = useDeliveryAddress()
  const { setDeliveryAddress } = useAddressStoreActions()

  const handleSelectedAddress = (selectedAddress: ApiAddressSuggestion) => {
    setMarkerCoordinates({
      latitude: selectedAddress.representasjonspunkt.lat,
      longitude: selectedAddress.representasjonspunkt.lon,
    })
    setViewport({
      latitude: selectedAddress.representasjonspunkt.lat,
      longitude: selectedAddress.representasjonspunkt.lon,
      zoom: 17,
    })
    setDeliveryAddress(selectedAddress)
  }

  const handleClearAddress = () => {
    setMarkerCoordinates(OSLO_LOCATION)
    setViewport(INITIAL_VIEWPORT)
    setDeliveryAddress(undefined)
  }

  useEffect(() => {
    if (deliveryAddress) {
      handleSelectedAddress(deliveryAddress)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="flex w-full flex-col items-start gap-5">
      <div className="flex min-h-[400px] grow flex-col items-stretch justify-between self-stretch">
        <PickupLocationForm
          deliveryAddress={deliveryAddress}
          pickupDateBag={pickupDateBag}
          setIsInErrorState={setIsInErrorState}
          handleSelectedAddress={handleSelectedAddress}
          handleClearAddress={handleClearAddress}
        />
      </div>
      <div className="mt-12 h-[350px] w-full overflow-hidden rounded-xl lg:h-[550px]">
        <PickupLocationMap viewport={viewport} setViewport={setViewport} location={markerCoordinates} />
      </div>
    </div>
  )
}
